module.exports = __webpack_public_path__ + "img/icon4.c890e6e8.png";